module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/buttons/button-large-border-60.png"+" 60w",
        images: [{path: __webpack_public_path__ + "assets/images/buttons/button-large-border-60.png",width: 60,height: 18}],
        src: __webpack_public_path__ + "assets/images/buttons/button-large-border-60.png",
        toString: function(){return __webpack_public_path__ + "assets/images/buttons/button-large-border-60.png"},
        
        width: 60,
        height: 18
      }